import Tr from 'translations/Translations';

export const CONDITION_TYPE_OTHER = "OTHER";

export const CONDITION_TYPE = {
	COMPETENCES: "COMPETENCES",
	FINANCIAL_SITUATION: "FINANCIAL_SITUATION",
	TECHNICAL_CAPACITY: "TECHNICAL_CAPACITY",
	EMPLOYMENT: "EMPLOYMENT",
	OTHER: CONDITION_TYPE_OTHER
}

export const CONDITION_TYPE_PZP_2021 = {
	COMPETENCES: "COMPETENCES",
	FINANCIAL_SITUATION: "FINANCIAL_SITUATION",
	TECHNICAL_CAPACITY: "TECHNICAL_CAPACITY",
	EMPLOYMENT: "EMPLOYMENT",
	COURSE_OF_TRADE: "COURSE_OF_TRADE",
	OTHER: CONDITION_TYPE_OTHER
}

export const CONDITIONS_LABEL = {
	[CONDITION_TYPE.COMPETENCES]: Tr('condition_type_competences'),
	[CONDITION_TYPE.FINANCIAL_SITUATION]: Tr('condition_type_financial_situation'),
	[CONDITION_TYPE.TECHNICAL_CAPACITY]: Tr('condition_type_technical_capacity'),
	[CONDITION_TYPE.EMPLOYMENT]: Tr('condition_type_employment'),
	[CONDITION_TYPE.OTHER]: Tr('other'),
}

export const CONDITIONS_LABEL_PZP_2021 = {
	[CONDITION_TYPE_PZP_2021.COMPETENCES]: Tr('condition_type_competences_2'),
	[CONDITION_TYPE_PZP_2021.FINANCIAL_SITUATION]: Tr('condition_type_financial_situation'),
	[CONDITION_TYPE_PZP_2021.TECHNICAL_CAPACITY]: Tr('condition_type_technical_capacity'),
	[CONDITION_TYPE_PZP_2021.EMPLOYMENT]: Tr('condition_type_employment'),
	[CONDITION_TYPE_PZP_2021.COURSE_OF_TRADE]: Tr('condition_type_course_of_trade'),
	[CONDITION_TYPE_PZP_2021.OTHER]: Tr('other')
}

const createItem = (key) => ({
	label: CONDITIONS_LABEL[key],
	value: key
})

const createItem_PZP_2021 = (key) => ({
	label: CONDITIONS_LABEL_PZP_2021[key],
	value: key
})

export const conditionValues_PZP_2021 = Object.keys(CONDITION_TYPE_PZP_2021).map(x => createItem_PZP_2021(x));

export default Object.keys(CONDITION_TYPE).map( x => createItem(x))